import { css, html, LitElement } from "lit-element/lit-element.js";
import { customElement } from "lit/decorators/custom-element.js";
import { HorizontalStackElementModel, HorizontalStackSettingsElementModel } from "../../api/ContentDeliveryApi.schemas";
import { UmbracoPage } from "../../ContentLoader";
import { renderElement } from "../../RenderElement";

@customElement('lindberg-horizontal-stack')
export class HorizontalStack extends LitElement {
    static styles = css`
        :host {
            box-sizing: border-box;
            display: grid;
            grid-auto-flow: column;
            grid-auto-columns: 1fr;
            overflow-y: visible;

            gap: var(--grid-gutter);
            /* padding: var(--space-100); */
            width: 100%;
            
            @media (width < 600px) {
                grid-auto-flow: row;
                gap: var(--space-300);
                padding: var(--space-200);
            }

            & > * {
                height: 100%;
            }
        }

        :host(.no-gap){
            --grid-gutter: 0px;
        }

        :host(.col-6-3-3){
            grid-template-columns: 2fr;
            grid-auto-columns: 1fr;
            gap: var(--grid-gutter);
            padding: 0;

            @media (width < 600px) {
            /* @media (600px <= width < 912px) { */
                grid-auto-flow: row;
                grid-template-columns: 1fr 1fr;

                > :first-child {
                    grid-column: 1 / -1;
                }
            }
        }

    `
    data!: { content: HorizontalStackElementModel; settings?: HorizontalStackSettingsElementModel }
    root!: UmbracoPage;
    
    connectedCallback() {
        super.connectedCallback()        
        if(this.data.settings?.properties.variant) this.classList.add(this.data.settings.properties.variant)
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
    }
    
    render = () => html`${this.data.content.properties.items?.items.map(x => renderElement(x, this.root))}`
}